// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__-z7DK","selected":"Chip_selected__1GZ2z"};